import { Component, inject } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';
import { ModalService } from '../../../../services';
import { MSS_FORMLY_IMPORTS } from '../../formly-standalone-imports';

@Component({
  selector: 'lib-fw-horizontal-wrapper',
  templateUrl: './horizontal-wrapper.component.html',
  styleUrls: ['./horizontal-wrapper.component.scss'],
  imports: [...MSS_FORMLY_IMPORTS],
})
export class FormlyHorizontalWrapperComponent extends FieldWrapper {
  private readonly modalService = inject(ModalService);

  get labelIndentCssClass(): string {
    return this.props.labelIndent ? 'pl-5' : null;
  }

  get controlColumnClass(): string {
    return this.props.label || this.props.helpText ? 'col-md-6' : 'col-md-12';
  }

  get shouldRenderHelpColumn(): boolean {
    return !!this.props.label || !!this.props.helpText;
  }

  openTooltip(triggerButton: HTMLElement) {
    this.modalService
      .open({
        title: this.props.label,
        message: this.props.helpText,
        hideClose: true,
        showButtons: true,
        hideSubmit: true,
        cancelLabel: 'Close',
        defaultFocus: 'content',
      })
      .then(
        () => triggerButton.focus(),
        () => triggerButton.focus(),
      );
  }

  close() {
    this.modalService.close();
  }
}
